<template>
  <div class="result-page">123
<!--    <template v-if="orderInfo">-->
<!--      <div style="height: 200px;text-align: center;display: flex;flex-direction: column;justify-content: center;align-items: center">-->
<!--        <tr-loading v-if="isPaying"></tr-loading>-->
<!--        <svg-icon v-else icon-class="zf_zfcg" class-name="zf_zfcg"></svg-icon>-->
<!--        <div style="margin-top: 10px">{{ isPaying ? '支付中' : '支付成功' }}</div>-->
<!--      </div>-->
<!--      <div class="operate-btn">-->
<!--        <div @click="linkTo('home')">返回首页</div>-->
<!--        <div @click="linkTo('orderDetails')">查看详情</div>-->
<!--      </div>-->
<!--    </template>-->
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookie";
export default {
  name: 'resultPage',
  data(){
    return{
      isPaying: true,
      interval: null,
      orderInfo: {},
    }
  },
  methods: {
    linkTo(url){
      // const payType = getCookie('payType')
      // const queryData = {
      //   Id: this.orderInfo.BusinessId
      // }
      // let routerUrl = url
      // if (payType === 'advance') {
      //   routerUrl = 'advanceDetail'
      //   queryData.backUrl = 'manage'
      //   queryData.title = '预收详情'
      //   queryData.backQuery = JSON.stringify({ backUrl: 'home' })
      // }else {
      //   queryData.backUrl = 'userOrder'
      //   queryData.backQuery = JSON.stringify({ backUrl: 'user' })
      // }
      // this.$router.replace({ name: routerUrl, query: url === 'home' ? {} : queryData })
    },
    async getOrderInfoByMember() {
      this.orderInfo = { aa: '黑黑' }
      // try {
      //   const res = await this.$post('/BizMemberOrder/OrderInfoByMember',{ Type: getCookie('payType') === 'advance' ? '预收' : '租赁' })
      //   if (res.Status === 1) {
      //     this.orderInfo = res.Data
      //     this.isPaying = res.Data.State === '待支付'
      //     if (res.Data.State !== '待支付') {
      //       clearInterval(this.interval)
      //       this.interval = null
      //     }
      //   }
      // }catch (e) {
      // }
    },
    sendReadyEvent() {
      const mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
        height: 200
      };
      window.parent.postMessage(JSON.stringify(mchData), 'https://payapp.weixin.qq.com');
    }
  },
  mounted() {
    this.$nextTick(() => {
      const mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE'
      };
      // window.parent.postMessage(
      //     JSON.stringify(mchData),
      //     'https://payapp.weixin.qq.com' // 必须精确匹配目标域
      // );
      top.postMessage(mchData, '*')
    });
    // this.getOrderInfoByMember()
    // this.interval = setInterval(() => {
    //   this.getOrderInfoByMember()
    // },5000)
  },
  beforeDestroy(){
    // clearInterval(this.interval)
    // this.interval = null
  }
}


</script>

<style scoped lang="less">
.result-page{

  .operate-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    >div{
      text-align: center;
      padding: 8px 0;
      border-radius: 8px;
      color: #ffffff;
      width: 30%;
      background-color: #00b3f3;
      &:nth-child(1){
        margin-right: 20px;
        background-color: #CCCCCC;
      }
    }
  }

  .zf_zfcg{
    font-size: 80px;
  }
}
</style>
